/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    VolumeBeeGFSStatus,
    VolumeBeeGFSStatusFromJSON,
    VolumeBeeGFSStatusFromJSONTyped,
    VolumeBeeGFSStatusToJSON,
    VolumeLizardFSStatus,
    VolumeLizardFSStatusFromJSON,
    VolumeLizardFSStatusFromJSONTyped,
    VolumeLizardFSStatusToJSON,
    VolumeSNFSStatus,
    VolumeSNFSStatusFromJSON,
    VolumeSNFSStatusFromJSONTyped,
    VolumeSNFSStatusToJSON,
} from './';

/**
 * 
 * @export
 * @interface VolumeStatus
 */
export interface VolumeStatus {
    /**
     * 
     * @type {boolean}
     * @memberof VolumeStatus
     */
    online: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof VolumeStatus
     */
    sizeTotal: number | null;
    /**
     * 
     * @type {number}
     * @memberof VolumeStatus
     */
    sizeUsed: number | null;
    /**
     * 
     * @type {number}
     * @memberof VolumeStatus
     */
    sizeFree: number | null;
    /**
     * 
     * @type {VolumeSNFSStatus}
     * @memberof VolumeStatus
     */
    snfs?: VolumeSNFSStatus;
    /**
     * 
     * @type {VolumeLizardFSStatus}
     * @memberof VolumeStatus
     */
    lizardfs?: VolumeLizardFSStatus;
    /**
     * 
     * @type {VolumeBeeGFSStatus}
     * @memberof VolumeStatus
     */
    beegfs?: VolumeBeeGFSStatus;
}

export function VolumeStatusFromJSON(json: any): VolumeStatus {
    return VolumeStatusFromJSONTyped(json, false);
}

export function VolumeStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): VolumeStatus {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'online': json['online'],
        'sizeTotal': json['size_total'],
        'sizeUsed': json['size_used'],
        'sizeFree': json['size_free'],
        'snfs': !exists(json, 'snfs') ? undefined : VolumeSNFSStatusFromJSON(json['snfs']),
        'lizardfs': !exists(json, 'lizardfs') ? undefined : VolumeLizardFSStatusFromJSON(json['lizardfs']),
        'beegfs': !exists(json, 'beegfs') ? undefined : VolumeBeeGFSStatusFromJSON(json['beegfs']),
    };
}

export function VolumeStatusToJSON(value?: VolumeStatus | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'online': value.online,
        'size_total': value.sizeTotal,
        'size_used': value.sizeUsed,
        'size_free': value.sizeFree,
        'snfs': VolumeSNFSStatusToJSON(value.snfs),
        'lizardfs': VolumeLizardFSStatusToJSON(value.lizardfs),
        'beegfs': VolumeBeeGFSStatusToJSON(value.beegfs),
    };
}


